module.exports = __webpack_public_path__ + "d99f41b1a9f17e540300ab098ba76e3e.svg";